<template>
    <div>
        <v-layout justify-center align-center>
            <v-flex xs12 sm7 md7>
                <dialogos-app :dialogos="dialogos" tucan="0" @update:currentText="noclik = false"></dialogos-app>
            </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center mt-4 class="cont_page" :class="{'noclick':noclik}">
            <v-flex xs10 sm7 md7 text-xs-center>
                <button @click="openModal(0)" class="hvr hvr-scale" :class="{'bot-check-vis-cen':vistos[0]}">
                  <img src="@/assets/presentacion/diap-1.png" alt="">
                </button>
            </v-flex>
            <v-flex xs10 sm7 md7 text-xs-center mt-5>
                <button @click="openModalLogo(1)" class="hvr hvr-scale" :class="{'bot-check-vis-cen':vistos[1]}" >
                  <img src="@/assets/presentacion/diap-1-2.svg" alt="">
                </button>
            </v-flex>
        </v-layout>

        <!-- MODAL CON EL MAPA -->
        <modal-app v-model="modal" :fullscreen="true">
            <template slot="modaltittle">
                <h1 class="modal-icon-title"></h1>
            </template>
            <v-layout justify-center wrap>
              <v-flex xs12 sm7 md7 >
                  <dialogos-app :dialogos="dialogosModal" tucan="0"></dialogos-app>
              </v-flex>
            </v-layout>
            <v-layout justify-center align-center wrap mt-4>
              <v-flex xs12 sm7 md5>
                  <svgslidemapa @regioncont="regionCont"></svgslidemapa>
              </v-flex>
              <!-- <v-flex xs12 sm7 md3>
                  <div class="cont_mapa-nombre">
                    <button class="hvr-scale btn_region" :style="{'background':colorBack[regionName]}"
                    @click="openModalRegion(regionName)">
                      <p>{{textoMapa[regionName]}}</p>
                    </button>
                  </div>
              </v-flex> -->
            </v-layout>
        </modal-app>
      <!-- MODAL DE LAS REGIONES -->
        <modal-app v-model="modalMapa" :fullscreen="true" :backColorCerrar="colorBack[regionName]" heightCerrar="50px">
            <template slot="modaltittle">
                <h1 class="modal-icon-title" :class="{'textblack':regionName == 0}">
                  {{textoMapa[regionName]}}
                </h1>
            </template>
            <v-layout justify-center wrap>
              <slideregion1 v-if="regionName == 0"></slideregion1>
              <slideregion2 v-if="regionName == 1"></slideregion2>
              <slideregion3 v-if="regionName == 2"></slideregion3>
              <slideregion4 v-if="regionName == 3"></slideregion4>
              <slideregion5 v-if="regionName == 4"></slideregion5>
            </v-layout>
        </modal-app>
      <!-- MODAL DE LAS REGIONES -->
        <modal-app v-model="modalLogo" :fullscreen="true">
            <template slot="modaltittle">
                <h1 class="modal-icon-title"></h1>
            </template>
            <v-layout justify-center wrap>
              <slidelogo></slidelogo>
            </v-layout>
        </modal-app>

    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
import svgslidemapa from '@/pages/presentacion/slide-svg/presentacion-mapa';
import slideregion1 from '@/pages/presentacion/slide-svg/slideregion1';
import slideregion2 from '@/pages/presentacion/slide-svg/slideregion2';
import slideregion3 from '@/pages/presentacion/slide-svg/slideregion3';
import slideregion4 from '@/pages/presentacion/slide-svg/slideregion4';
import slideregion5 from '@/pages/presentacion/slide-svg/slideregion5';
import slidelogo from '@/pages/presentacion/slide-svg/slidelogo';

export default {
    components: {
        svgslidemapa,
        slideregion1,
        slideregion2,
        slideregion3,
        slideregion4,
        slideregion5,
        slidelogo
    },
  mixins: [nextConditions],
  data() {
    return {
      dialogos: [
        'Oi, eu sou o <span class="instruccion">Tuca </span>e estou muito feliz de conhecer você.',
        'Quero que você visite alguns lugares lindos do Brasil.'
      ],
      dialogosModal:[
        'Este é meu país: Brasil. Veja o mapa e conheça os seus 26 estados e o Distrito Federal.<br><br>Clique nas regiões. Vamos lá!' 
      ],
      textoMapa:[
        'Região Norte',
        'Região Nordeste',
        'Região Centro-Oeste',
        'Região Sudeste',
        'Região Sul',
      ],
      colorBack:[
        '#FFB900',
        '#00569F',
        '#E46000',
        '#D2000E',
        '#3C7A25'
      ],
      regionName:null,
      modal:false,
      modalMapa:false,
      modalLogo:false,
      vistos:Array(2).fill(false),
      noclik:true
    }
  },
  // created(){
  //   this.$store.commit('nextShow', true);
  // },
  methods: {
    openModal(val){
      this.modal = true
      this.$set(this.vistos,val,true)
    },
    openModalLogo(val){
      this.modalLogo = true
      this.$set(this.vistos,val,true)
    },
    regionCont(num){
      this.regionName = num
      setTimeout(() => {
        this.modalMapa = true
      }, 800);
    },
    openModalRegion(val){
      this.modalMapa = true
    }
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';
.cont_page{
  transition: all 0.3s ease-out;
}
.btn_region{
  border-radius: 4px;
  display: flex;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  padding: 20px;
  p{
    margin: 0;
    padding: 0;
    font-family: Poppins-Bold;
    font-style: 18px;
    color: white;

  }
}
.modal-icon-title{
    font-family: Poppins-Bold;
    font-style: 16px;
    color: white;
    margin-bottom: 10px;
}
.textblack{
  color: black;
}
.noclick{
  pointer-events: none;
  opacity: 0.4!important;
}
</style>
